<template >
    <div class="container-fluid" v-if="lesson!=null && topic!=null && content!=null">

      <div class="card shadow mb-4" >
        <div class="card-header py-3">
          <div class="row">
            
            <h4 class="m-0 font-weight-bold text-primary">Шалгалтын дүн </h4>
          </div>
        </div>
        <div class="card-body">
          <p>Хичээл: {{lesson.name}}</p>
          <p>Сэдэв: {{topic.name}}</p>
          <p >Тест: {{content.name}}</p>
          <p v-if="content">Нийт авах ёстой оноо: {{content.totalScore}}</p>
          <div v-if="content.yvz">
            <p>
              <span class="badge badge-success">явцын дүн хадгалагдсан</span>
            </p>
            <button @click="$router.push({ name: 'ILessonScores', params: { lessonId: lesson.id} })" class="btn btn-primary">Явцын дүнгүүд харах</button>
          </div>
          <div v-else>
            <button @click="setYvzScore" class="btn btn-success">Явцын дүн болгох</button>
          </div>

          <hr/>


          <div class="">

            <div class="">

              <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0" v-if="tmpStudents!=null && tmpStudents.length>0">
                <thead>
                  <tr>
                    <th>№</th>
                    <th>Овог/Нэр</th>
                    <th>Оюутны дугаар</th>
                    <th>Авсан оноо</th>
                    <th>Зөв/буруу</th>
                    <th>Төлөв</th>
                    
                    <th>Үйлдэл</th>

                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(std, index) in tmpStudents" v-bind:key="std.id" v-bind:style="std.block!=null && std.block!=undefined && std.block==true?{ 'border-bottom':'2.5px solid red' }:{}" >
                    <td>{{index+1}}</td>
                    <td><span v-if="std.student!=null">{{std.student.lastname}}/{{std.student.name}}</span></td>
                    <td><span v-if="std.student!=null">{{std.student.code}}</span></td>
            
                    <td>
                      
                      <div v-if="std.scoreData"  class="text-bold">
                        <span v-if="std.scoreData.earnedScore!=null && std.scoreData.earnedScore!=undefined">
                          {{std.scoreData.earnedScore}}
                        </span>
                        <span v-else class="text-primary">Шалгалт өгч дуусаагүй</span>
                        <br/>
                      </div>
                      <span v-else class="text-danger">Шалгалт өгөөгүй</span>
                    </td>
                    <td>
                      
                      <div v-if="std.block!=null && std.block!=undefined && std.block==false">
                        <div v-if="std.scoreData">
                          <span class="text-success" v-if="std.scoreData.answeredCorrect!=null && std.scoreData.answeredCorrect!=undefined">
                            Зөв хариулт: {{std.scoreData.answeredCorrect}}
                          </span>
                          <span v-else>0</span>
                          <br/>
                          <span class="text-danger" v-if="std.scoreData.answeredIncorrect!=null && std.scoreData.answeredIncorrect!=undefined">
                            Буруу хариулт: {{std.scoreData.answeredIncorrect}}
                          </span>
                          <span v-else>0</span>
                        </div>
                        <span v-else class="text-danger">-</span>
                      </div>
                    </td>
                    <td>
                      <div v-if="std.block!=null && std.block!=undefined && std.block==true">
                        <span class="badge badge-danger" style="font-size:16px;">шалгалт өгөх эрхгүй</span>
                        
                      </div>
                      <div v-else>
                        <div v-if="std.block!=null">
                          <span class="badge badge-success"  style="font-size:16px;">шалгалт өгөх эрхтэй</span>
                        </div>
                        <div v-else>LOADING....</div>
                      </div>
                      <div v-if="std.status!=null && std.status!=undefined && std.status==true">
                        <div v-if="std.scoreData"  class="text-bold">
                          <span v-if="std.scoreData.finished!=null && std.scoreData.finished!=undefined && std.scoreData.finished==true" >
                            Дууссан
                          </span>
                          <span v-else class="text-primary"> дуусаагүй</span>
                          <br/>
                        </div>
                        <span v-else class="text-danger">-</span>
                      </div>
                    </td>
                    <td>
                      <div  v-if="std.block!=null && std.block!=undefined && std.block==false">
                        <button class='btn btn-sm btn-primary mx-1' @click="calculateScore(std.scoreData)" >Дүн бодох</button>
                        <button class='btn btn-sm btn-danger mx-1' @click="resetTest(std.scoreData)">Шалгалт дахин эхлүүлэх эрх нээх</button>
                        <button class='btn btn-sm btn-secondary mx-1'  @click="setStudentAccess(std, true)">Шалгалт өгөх эрх хаах</button>
                      </div>
                      <div v-else>
                        <button class='btn btn-sm btn-danger mx-1' @click="setStudentAccess(std, false)">Шалгалт өгөх эрх нээх</button>
                      </div>
                      
                    </td>
                  </tr>
                  
                </tbody>
              </table>
              <div v-else class="alert alert-info text-center">
                  Одоогоор энэ хичээлийг үзэж байгаа оюутан байхгүй байна.
              </div>

            </div>
          </div>
            
        </div>

      </div>

      <div v-if="loading==true" style="position:fixed;z-index:10000000; top:45%;left:45%">
          <div class="spinner-grow text-primary" role="status">
              <span class="sr-only">Loading...</span>
          </div>
          <div class="spinner-grow text-secondary" role="status">
              <span class="sr-only">Loading...</span>
          </div>
          <div class="spinner-grow text-success" role="status">
              <span class="sr-only">Loading...</span>
          </div>
          <div class="spinner-grow text-danger" role="status">
              <span class="sr-only">Loading...</span>
          </div>
          <div class="spinner-grow text-warning" role="status">
              <span class="sr-only">Loading...</span>
          </div>
          <div class="spinner-grow text-info" role="status">
              <span class="sr-only">Loading...</span>
          </div>
          <div class="spinner-grow text-dark" role="status">
              <span class="sr-only">Loading...</span>
          </div>
      </div>
    </div>
    
</template>

<script>
const fb = require('../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment from 'moment'
import PieChart from "../PieChart.js";

export default {
    name: "ExamResult",
    components: {
      PieChart
    },
    data() {
        return {
          lesson:null,
          topic:null,
          content:null,
          answered:false,
          general:null,
          rounds:[],
          categories: [],

          chartOptions: {
            responsive: false, 
            maintainAspectRatio: false,
            pieceLabel: {
              mode: 'percentage',
              precision: 1
            }
          },
          tmpStudents:[],
          loading:false
        };
    },
    methods: {  
        async calculateScore(scoreData){
          var r = confirm("Энэ үйлдлийг хийсэнээр оюутаны шалтгалтын эцсийн дүн бодогдож дахин шалгалт өгөх боломжгүй болно.Зөвшөөрч байна уу.");
          if (r == true) {
            if(scoreData.path!=null && scoreData.path!=undefined && scoreData.path!=''){
              var submitAnswerFunction = firebase.functions().httpsCallable('finishRound');
              var object={
                user:scoreData.yj3b0XHGc4UafflaVcgHGVYCXkT2,
                testPath:fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc(this.topicId).collection('details').doc(this.contentId).path,
                round: scoreData.id,
                topicPath:fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc(this.topicId).path,
                lessonPath:fb.db.collection("lessons").doc(this.lessonId).path,

              };
              this.finished=true;
              submitAnswerFunction(
                object
              ).then((result) => {
                alert("Дүн амжилттай бодогдлоо.");
              })
              .catch(function (error) {
                console.log(error)
              });
            }
          } 

      },
      async resetTest(scoreData){
        var r = confirm("Энэ үйлдлийг хийсэнээр оюутан шалгалтаа дахин эхлүүлэх боломжтой болно.Зөвшөөрч байна уу.");
        if (r == true) {
          if(scoreData.path!=null && scoreData.path!=undefined && scoreData.path!=''){
          fb.db.doc(scoreData.path).update({
              'finished':false,
              'resetAt': fb.firestore.FieldValue.arrayUnion(new Date()),
              'reset':true
            });
          }
        } 

      },
      getData(){
        // if(this.$store.getters.userProfile!=null && this.$store.getters.userProfile.customer!=null){
        //   fb.db.collection("lessons").doc(this.lessonId).collection("studentList").doc(this.$store.getters.userProfile.customer.id).onSnapshot(stdDoc=> {
        //     if(stdDoc.exists && stdDoc.data().enabled==true){
              fb.db.collection("lessons").doc(this.lessonId).get().then(doc=> {
                  let lesson=doc.data()
                  lesson.id=doc.id
                  this.lesson=lesson;
                  
              });
              fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc(this.topicId).get().then(doc=> {
                  let topic=doc.data()
                  topic.id=doc.id
                  this.topic=topic;
              });
              fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc(this.topicId+"/details/"+this.contentId).get().then(doc=> {
                  let content=doc.data()
                  content.id=doc.id
                  this.content=content;
                  fb.db.collection("lessons/"+this.lessonId+'/studentList').get().then(querySnapshot=> {
                      this.tmpStudents=[];
                      querySnapshot.forEach(stddata=> {
                        let object=stddata.data()
                        object.id = stddata.id;
                        object.student=null;
                        object.ref=stddata.ref;
                        object.scoreData=null;
                        object.block=null;
                        if(stddata.data().studentRef!=null){
                          stddata.data().studentRef.get().then(studentDoc=>{
                            object.student=studentDoc.data();
                            object.student.id=studentDoc.id;
                            if(studentDoc.data().user!=null){
                              doc.ref.collection('users').doc(studentDoc.data().user.id).collection("rounds").doc("1").onSnapshot((userRoundDoc)=>{
                                if(userRoundDoc.exists){
                                  object.scoreData=userRoundDoc.data();
                                  object.scoreData.id=userRoundDoc.id;
                                  object.scoreData.path=userRoundDoc.ref.path;
                                }
   
                              });

                              doc.ref.collection('users').doc(studentDoc.data().user.id).onSnapshot((userRoundDoc)=>{
                                if(userRoundDoc.exists){
                                  if(userRoundDoc.data().block && userRoundDoc.data().block==true){
                                    object.block=true;
                                  }
                                  else 
                                    object.block=false;
                                }
                                else
                                  object.block=false;
                              });


                            }
                            else
                                  object.block=false;
                            
                          });
                        }
                        else
                                  object.block=false;


                        this.tmpStudents.push(object);
                      });
                    
                  });
                  
              });


          //   }
          // });
            
            
        // }
      },
      setProperty(propertyName, object, value){
        if(object!=null && propertyName!=null){
          var tmp={};
          tmp[propertyName]=value;
          object.update(tmp);
        }
      },
      async _getQuestionsOfCategory(cat, catRef){
        var querySnapshot=await catRef
          .collection("questions").orderBy("createdAt","asc").get()
            cat.questions=[];
            for(const doc of querySnapshot.docs){
              let question=doc.data();
                question.id=doc.id;
                question.subquestions=[];

                var subDocs= await doc.ref.collection("subquestions").get();
                for(const subquestion of subDocs.docs){
                  let object=subquestion.data();
                  object.id = subquestion.id;
                  object.answers=[];

                  if(object.answertype==true){
                    // object.useranswers=[]
                    // this._getQuestionAnswers(object, subquestion.ref);
                  }
                  else{
                    object.answers = [];
                    await this._getAnswers(object, subquestion.ref);
                  }

                  question.subquestions.push(object);
                }

                cat.questions.push(question);
           
            }


      },
      async _findCategories(){
        var querySnapshot= await fb.db.collection("lessons/" + this.lessonId + "/topics/"+this.topicId+"/details/"+this.contentId+"/tests").orderBy("createdAt","asc").get();
        this.categories = [];
        for(const doc of querySnapshot.docs){
          let cat = doc.data();
          cat.id = doc.id;
          cat.questions=[]
          await this._getQuestionsOfCategory(cat, doc.ref)
          this.categories.push(cat);
        }

        

      },
      async _getAnswers(question, ref) {
        if (question.answers == null || question.answers == undefined)
          question.answers = [];
        var querySnapshot=await ref
          .collection("answers")
          .get();
            question.answers = [];
            let index = 0;
            querySnapshot.docs.forEach(doc => {
              let answer = doc.data();
              answer.id = doc.id;

              question.answers.push(answer);
              index++;
            });
        
   
      },
      getUserAnswers(content){
        content.ref.collection("users").doc(this.currentUser.uid).get().then(userAnswerDoc=>{
          if(userAnswerDoc.exists){
            this.answered=true;
            this.general=userAnswerDoc.data();
            userAnswerDoc.ref.collection('rounds').orderBy('createdAt', "desc").get().then(roundsData=>{
              this.rounds=[];
              if(!roundsData.empty){
                roundsData.forEach(value=>{
                  let round=value.data();
                  round.id=value.id;
                  var chartData= {
                    labels: ["Зөв", "Буруу"],
                    datasets: [
                      {
                        label: "Статистик",
                        backgroundColor: ["#41B883", "#E46651"],
                        data: [
                          round.answeredCorrect!=null && round.answeredCorrect!=undefined?round.answeredCorrect:0,
                          round.answeredIncorrect!=null && round.answeredIncorrect!=undefined?round.answeredIncorrect:0
                        ]
                      }
                    ]
                  }
                  round.chartData=chartData;
                  console.log(round.chartData);
                  this.rounds.push(round);
                });
              }
            });
          }
          
          else
            this.answered=false;
        });
      },

      async setYvzScore(){
        var r = confirm("Та бүх оюутнууд шалгалтаа өгч дуусан бол дүнгээ баталгаажуулна уу");
        if (r == true) {
          this.loading=true;
          var querySnapshot=await fb.db.collection("lessons/"+this.lessonId+'/studentList').get();
          if(content && querySnapshot && !querySnapshot.empty){
            var batch=fb.db.batch();
            var scoreRef=fb.db.collection("lessons/"+this.lessonId+'/scores').doc();
            var now=new Date();
            batch.set(
              scoreRef,
              {
                name: this.content.name,
                createdAt: now,
                totalScore: this.content.totalScore,
                code: now.getTime()
              }
            );
            for(const stddata of querySnapshot.docs){
              let object=stddata.data();
              object.id = stddata.id;
              object.student=null;
              object.ref=stddata.ref;
              object.scoreData=null;
              if(stddata.data().studentRef){
                var studentDoc=await stddata.data().studentRef.get();
                object.student=studentDoc.data();
                if(studentDoc.data().user){
                  var userRoundDoc=await fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc(this.topicId+"/details/"+this.contentId).collection('users').doc(studentDoc.data().user.id).collection("rounds").doc("1").get();
                    if(userRoundDoc.exists && userRoundDoc.data().finished==true){
                      var maxScore=100;
                      if(this.content.totalScore){
                        maxScore=this.content.totalScore;
                      }

                      var procent=null;
                      if(maxScore && userRoundDoc.data().earnedScore){
                        procent=(userRoundDoc.data().earnedScore*100/maxScore)
                      }
                      batch.set(
                        scoreRef.collection("sstudents").doc(studentDoc.id),
                        {
                          earnedScore: userRoundDoc.data().earnedScore?userRoundDoc.data().earnedScore:0,
                          modifiedAt: now,
                          procent : procent? procent:0

                        }

                      );
                    }
                    else{
                      batch.set(
                        scoreRef.collection("sstudents").doc(studentDoc.id),
                        {
                          earnedScore: 0,
                          modifiedAt: now,
                          procent :0

                        }
                      );
                    }

                }

              }
            }
            batch.update(
              fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc(this.topicId+"/details/"+this.contentId),
              {
                yvz:scoreRef
              }
            );
            batch.update(
              fb.db.doc("lessons/"+this.lessonId),
              {
                'numberOfYvts':fb.firestore.FieldValue.increment(1)
              }
            );
            await batch.commit();
            alert("Явцын дүн амжилттай хадгалагдлаа");
            this.content.yvz=scoreRef;
          }
          this.loading=false;
        }
        
      },
      async setStudentAccess(std, value){
        var batch=fb.db.batch();
        var stddata=await fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc(this.topicId+"/details/"+this.contentId).collection('users').doc(std.student.user.id).get();

        if(stddata.exists){
          batch.update(
            stddata.ref,
            {
              block: value
            }
          );
            
        }
        else{
          batch.set(
            stddata.ref,
            {
              block: value,
              createdAt:new Date()
            }
          );
        }
        await batch.commit();
        std.block=value;
        
      }
    },

    
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    props: {
        lessonId: { 
            required: true,
        },
        topicId:{
          required:true
        },
        contentId:{
          required:true
        }
    },
    created() {
      if(this.lessonId!=null && this.lessonId!='' && this.topicId!=null && this.topicId!='' && this.contentId!=null && this.contentId!='')
        this.getData();
          
    },
    filters: {
        formatDateFromNow(val) {
            if (!val) { return '-' }
            let date = val.toDate()
            return moment(date).fromNow()
        },
        formatDate(val) {
            if (!val) { return '-' }
            let date = val.toDate()
            return moment(date).format('MM/DD/YYYY HH:mm');
        },
        trimLength(val) {
            if (val.length < 200) { return val }
            return `${val.substring(0, 200)}...`
        }
    }
  
};
</script>

